import React, { useEffect, useState } from "react";
import HeroBgAnimation from "../HeroBgAnimation";
import profile_pic from "../../images/profile_pic-1.png";
import {
  HeroContainer,
  HeroBg,
  HeroLeftContainer,
  Img,
  HeroRightContainer,
  HeroInnerContainer,
  TextLoop,
  Title,
  Span,
  SubTitle,
  ResumeButton,
} from "./HeroStyle";
import styled from "styled-components";
import Typewriter from "typewriter-effect";
import { Facebook, GitHub } from "@mui/icons-material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Box } from "@mui/material";

const FooterWrapper = styled.footer`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-top: 1.5rem;
  color: ${({ theme }) => theme.text_primary};
`;

const SocialMediaIcons = styled.div`
  display: flex;
  margin-top: 1rem;
`;

const SocialMediaIcon = styled.a`
  display: inline-block;
  margin: 0 1rem;
  color: ${({ theme }) => theme.text_primary};
  transition: color 0.2s ease-in-out;
  width: 48px;
  height: 48px;
  padding-top: 5px;
  padding-left: 5px;
  border-radius: 50%;
  background-color: #1c1e27;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
  &:hover {
    background-color: #fff;
    border-color: #1c1e27;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
    color: #1c1e27;
  }
`;

const HeroSection = ({ heroData }) => {
  return (
    <section id="about">
      <HeroContainer>
        <HeroBg>
          <HeroBgAnimation />
        </HeroBg>
        <HeroInnerContainer>
          <HeroLeftContainer>
            <Title>Hi, I am</Title>
            <TextLoop>
              <Span>
                <Typewriter
                  options={{
                    strings: heroData?.roles || [],
                    autoStart: true,
                    loop: true,
                  }}
                />
              </Span>
            </TextLoop>
            <SubTitle>{heroData?.description}</SubTitle>
            <ResumeButton
              href="/CV_Huynh_Phuoc_Tan.pdf"
              download="CV_Huynh_Phuoc_Tan.pdf"
              rel="noopener noreferrer"
              aria-label="View my CV"
            >
              Download My CV
            </ResumeButton>
            <FooterWrapper>
              <SocialMediaIcons>
                <SocialMediaIcon
                  href="https://www.facebook.com/PhuocTan.username/"
                  target="_blank"
                  aria-label="GitHub profile"
                >
                  <Facebook sx={{ fontSize: 35 }} />
                </SocialMediaIcon>
                <SocialMediaIcon
                  href="https://github.com/Tanas-IT"
                  target="_blank"
                  aria-label="GitHub profile"
                >
                  <GitHub sx={{ fontSize: 35 }} />
                </SocialMediaIcon>
                <SocialMediaIcon
                  href="https://www.linkedin.com/in/t%E1%BA%A5n-hu%E1%BB%B3nh-ph%C6%B0%E1%BB%9Bc-0291bb301/"
                  target="_blank"
                  aria-label="LinkedIn profile"
                >
                  <LinkedInIcon sx={{ fontSize: 35 }} />
                </SocialMediaIcon>
              </SocialMediaIcons>
            </FooterWrapper>
          </HeroLeftContainer>

          <HeroRightContainer>
            <Img src={profile_pic} alt={`Huynh Phuoc Tan - Profile Picture`} />
          </HeroRightContainer>
        </HeroInnerContainer>
      </HeroContainer>
    </section>
  );
};

export default HeroSection;
